
import api from '@/axios/api';
import {
  defineAsyncComponent,
  defineComponent, provide, reactive, ref, toRaw,
} from 'vue';
import commonStore from '@/store/common';
import { useRoute, useRouter } from 'vue-router';
import { Spin } from 'ant-design-vue';
import { ClassJobBasicInfoI, JobBasicInfoI, IJobModuleQuestionParse } from '../addJob/js/interface';
import { apiQueryData } from '../addJob/js/jobBasicInfo';
import { getPreviewData, transQuestionData } from './js/jobPreview';

/** 路由接受两个参数
 * analysisId 案例分析的id-用来查案例数据
 * view preview,see,submit
 *    - preview-教师预览-无数据-教师预览显示正确答案、
 *    - see-查看-有数据-显示学生答案、
 *    - submit-答题-只显示题目，不显示答案、
 */
export default defineComponent({
  components: {
    analysisHeader: defineAsyncComponent(() => import('@/components/teacher/jobAnalysis/analysisHeader.vue')),
    questionModules: defineAsyncComponent(() => import('@/components/teacher/jobAnalysis/questionModule.vue')),
    aSpin: Spin,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const view = route.query.view as string; // preview、see、submit
    const analysis = reactive<JobBasicInfoI>(new ClassJobBasicInfoI()); // 案例分析详情
    const moduleList = ref<IJobModuleQuestionParse[]>([]); // 问题模块
    const loadings = reactive({
      question: false,
    });
    provide('jobView', view);
    provide('userRole', commonStore.getState().role);

    const initInfo = async () => {
      const { data } = await api.queryCustomCaseAssignmentById(route.params.analysisId as string);
      Object.assign(analysis, apiQueryData(data.data));
      console.log(data.data, toRaw(analysis), 'this is adata');
    };
    const initQuestion = async () => {
      loadings.question = true;
      const { data } = await getPreviewData('id');
      moduleList.value = transQuestionData(data.data);
      loadings.question = false;
      console.log(111);
    };

    const goBack = () => {
      router.back();
    };
    initInfo();
    initQuestion();
    return {
      // loadign
      loadings,
      // data
      analysis,
      moduleList,
      view,
      // method
      goBack,
      initQuestion,
    };
  },
});
